import { createStore } from "@stencil/store";
import { PPNDealerSearchResult } from "../entities/dealer-response";
import windowService from "../services/window-service";
import { SAVED_DEALER_COOKIE } from "../utility/constants";

export interface DealerSearchResults {
  searchTerm: string;
  results: string[] | null;
  savedDealerCookie: SavedDealerCookie | null;
  ppnDealers: { [dealerId: string]: PPNDealerSearchResult };
  dealersOfRegion: any;
}

export interface SavedDealerCookie {
  id: string;
  latitude: number;
  longitude: number;
}

export const dealerSearchResultsStore = createStore<DealerSearchResults>({
  searchTerm: "",
  results: null,
  savedDealerCookie: readDealerCookie(),
  ppnDealers: {},
  dealersOfRegion: { regions: [] },
});

dealerSearchResultsStore.onChange("savedDealerCookie", (newValue) => {
  windowService.setCookie(SAVED_DEALER_COOKIE, JSON.stringify(newValue));
});

function readDealerCookie(): SavedDealerCookie | null {
  try {
    return JSON.parse(windowService.getCookie(SAVED_DEALER_COOKIE));
  } catch (err) {
    return null;
  }
}
